__turbopack_context__.v({
  "className": "sofia_sans_condensed_e6f4a0f7-module__VUrVyq__className",
});
